if (!customElements.get('request-quote-modal')) {
  customElements.define(
    'request-quote-modal',
    class RequestQuoteModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.request-quote-modal__trigger');
        this.closeButton = this.querySelector('.request-quote-modal__close');

        this.trigger.addEventListener('click', () => this.dialog.showModal());
        this.closeButton.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.dialog.close();
        });

        // Reopen automatically if the contact form just redirected back with a success/error state
        if (this.dialog.querySelector('.request-quote-modal__success, .request-quote-modal__error')) {
          this.dialog.showModal();
        }
      }
    }
  );
}